export default {
    ca: {
        slideOne: {
            title: 'Instamaps Euroregió',
        },
        slideTwo: {           
            title: 'Instamaps Euroregió',
        },
    },
    es: {
        slideOne: {
            title: 'Instamaps Euroregión',
        },
        slideTwo: {
            title: 'Instamaps Euroregión',
        },
    },
    en: {
        slideOne: {
            title: 'Instamaps Euroregion',
        },
        slideTwo: {
            title: 'Instamaps Euroregion',
        },
    },
};



// WEBPACK FOOTER //
// ./src/home-euroregio/components/banner-slider/banner-slider-translations.js